<template>
    <FormCard>
        <template #cardTitle>
            Requesting Doctor
        </template>
        <template #cardSubtitle>
            Enter the doctor's name in the format <span style="font-weight: 700;">Last Name, First Name (e.g., DELA CRUZ, JUAN).</span>
        </template>
        <template #cardText>
            <FilterDoctorByHosp
                :hosp="data.from.hosp"
                :hosp-items="data.from.hospItems"
                @setHosp="setHosp"
            />
            <FilterDoctor
                :data="data"
                @resetDoctor="resetDoctor"
            />
            <SearchDoctor
                :data="data"
                :trigger-reset-doctor="triggerResetDoctor"
                @saveNewDoctor="saveNewDoctor"
            />
        </template>
    </FormCard>
</template>

<script>
import FilterDoctorByHosp from './InputComp/FilterDoctorByHosp.vue'
import FilterDoctor from './InputComp/FilterDoctor.vue'
import SearchDoctor from './InputComp/SearchDoctor.vue'
import FormCard from './InputComp/FormCard.vue'
export default {
    components: {
        FilterDoctorByHosp,
        FilterDoctor,
        SearchDoctor,
        FormCard
    },
    props: ['data'],
    data: ()=>({
        triggerResetDoctor: 0
    }),
    methods: {
        setHosp(newVal) {
            this.$emit('setHosp', newVal)
            this.triggerResetDoctor++
        },
        saveNewDoctor(newVal) {
            this.$emit('saveNewDoctor', newVal)
        },
        resetDoctor(newVal) {
            this.$emit('resetDoctor', newVal)
            this.triggerResetDoctor++
        }
    }
}
</script>
